import { render, staticRenderFns } from "./BuilderBehaviorInput.vue?vue&type=template&id=72fff796&"
import script from "./BuilderBehaviorInput.vue?vue&type=script&lang=ts&"
export * from "./BuilderBehaviorInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports